import { z } from "zod";
import { getValueFromPath } from "./getValueFromPath";
/**
 * Applies a map of field validator functions to the corresponding values in the provided data object
 *
 * For each validator entry, it retrieves the value using the field path and runs validation logic.
 * If validation fails, it adds a Zod issue to the refinement context using the returned error message.
 *
 * @template T - The type of the form data object.
 * @param data - The full form data object to validate
 * @param ctx  - The Zod refinement context used to register custom validation issues.
 * @param fieldValidators - A map of field validator functions which validate form data for each form field.
 * @param delimiter - Optional argument to split the path by a certain delimiter default to "."
 */
export var applyFieldValidators = function (data, ctx, fieldValidators, delimiter) {
    if (delimiter === void 0) { delimiter = "."; }
    Object.entries(fieldValidators).forEach(function (_a) {
        var flatPath = _a[0], validate = _a[1];
        var value = getValueFromPath(data, flatPath, delimiter);
        var result = validate(value);
        if (result !== true) {
            ctx.addIssue({
                path: flatPath.split(delimiter),
                code: z.ZodIssueCode.custom,
                message: result,
            });
        }
    });
};
